{
  "pt": {
    "decision_type": {
      "actions": {
        "add_competitor": "Adicionar concorrente",
        "add_decision_partners": "Parceiros de decisão",
        "auto_share_proposals": "Partilha automática de propostas aprovadas",
        "change_rights": "Direitos de alteração",
        "collapse": "Recolher",
        "create_category": "Adicionar nova categoria",
        "delete": "Eliminar",
        "deleteMultiple": "Eliminar...",
        "delete_cancel": "Cancelar",
        "delete_group": "Eliminar grupo de parceiros",
        "download": "Descarregar",
        "edit": "Editar",
        "edit_decision_partners": "Editar parceiros de decisão",
        "import": "Importar",
        "manage": "Gerir",
        "new": "Novo",
        "newDecision": "Nova decisão",
        "newDecisions": "Decisão",
        "save": "Guardar",
        "show": "Mostrar",
        "start_new_group": "Iniciar um novo grupo",
        "submit": "Enviar"
      },
      "attributes": {
        "category": "Categoria",
        "created_at": "Criado em",
        "description": "Descrição",
        "name": "Título",
        "responsible": "Responsável",
        "start_date": "Data de início"
      },
      "labels": {
        "add_decision_partners": "Adicionar parceiros de decisão",
        "allowCreditExplainer": "Mostrar crédito para propostas abaixo do orçamento",
        "auto_close": "Encerrar a decisão automaticamente após o fim do prazo",
        "auto_close_info": "O encerramento de uma decisão impede que o cliente aprove uma proposta quando não foi tomada uma decisão. Isto é útil quando se trabalha com prazos apertados.",
        "auto_share": "Partilha auto",
        "auto_share_description": "Partilhar automaticamente propostas aprovadas com este grupo de parceiros",
        "auto_share_subtitle": "Quando uma nova proposta é aprovada",
        "auto_share_title": "Partilha automática de propostas aprovadas",
        "category_name": "Nome da categoria",
        "closes_on_deadline": "Encerra no prazo",
        "createNewPartner": "Ou criar um novo parceiro de decisão",
        "decision_type_category_description": "Atribuir uma categoria, como cozinha, casa de banho, etc., a várias decisões irá agrupá-las e permitir uma melhor supervisão",
        "deleteCategory": "Eliminar categoria {category}?",
        "deleteGroupSubtitle": "Esta ação removerá todas as conversas, propostas e documentos criados por todos em {group_name} de {decision_type_name}.",
        "deleteGroupTitle": "Está prestes a eliminar {group_name}",
        "disclaimerDeleteGroup": "A eliminação de {group_name} irá cancelar a publicação de todas as decisões para os parceiros de decisão. É possível publicar novamente para os parceiros de decisão quando esta decisão tiver novamente parceiros de decisão.",
        "disclamerDeleteCategory": "A eliminação de {category} removerá a categoria de todas as decisões a ela atribuídas. As decisões em si não serão eliminadas.",
        "editCategory": "Editar categoria",
        "editGroup": "Editar {group_name}",
        "editPartnerRights": "Editar direitos de comunicação do parceiro de decisão",
        "editPartnerRightsLater": "Pode sempre alterá-lo mais tarde",
        "edit_partner_group_eyebrow": "Editar grupo de parceiros",
        "existing_groups": "Grupos de parceiros existentes",
        "explainerPartners": "Adicionar parceiros de decisão externos e trabalhar em conjunto em {decision_type_name}",
        "export_preparing": "A recolha de todas as propostas pode demorar alguns minutos. Receberá uma notificação quando estiver pronto para ser descarregado.",
        "export_proposals_approved": "Documentos de propostas aprovadas",
        "for_decision": "Para decisão",
        "groupRightsWarning": "Atenção! Todas as conversas entre o Cliente e os Parceiros serão removidas. Esta ação é irreversível. Tem a certeza de que pretende continuar?",
        "hint": "Pode gerir as suas categorias nas",
        "hintSettings": "definições da empresa.",
        "last_updated_at": "Última atualização em",
        "matrix": "Estatísticas",
        "new_category": "Nova categoria de decisão",
        "new_partner_group": "Novo grupo de parceiros",
        "noPartnersAddedYet": "Ainda não foram adicionados parceiros de decisão",
        "noResultPartner": "Nenhum resultado para {partner_name}",
        "partner_already_in_other_group": "Já está noutro grupo",
        "partner_already_selected": "Já selecionado",
        "partner_group": "Grupo de parceiros",
        "partner_group_footer_empty": "Selecione pelo menos 1 parceiro",
        "partner_group_footer_summary": "{count} parceiro • {rights} | {count} parceiro • {rights} | {count} parceiros • {rights}",
        "partner_group_name_label": "Nome do grupo de parceiros",
        "partner_groups": "Grupos de parceiros",
        "partners": "Parceiros de decisão",
        "partners_count": "Nenhum parceiro | 1 parceiro | {count} parceiros",
        "partners_in_group": "Parceiros neste grupo",
        "partners_in_total": "Nenhum parceiro no total | 1 parceiro no total | {count} parceiros no total",
        "partners_selected_count": "Nenhum selecionado | 1 selecionado | {count} selecionado",
        "permissions_label": "Direitos de grupo",
        "projectUnitsTotal": "{project_name} tem {units_count_max} unidades no total",
        "proposal_uploaded": "proposta carregada",
        "published_state": "Estado da publicação",
        "searchPartners": "Pesquisar parceiros de decisão",
        "selectADecision": "Selecionar uma decisão",
        "select_decision_partners": "Selecione os seus parceiros de decisão",
        "setUpPartners": "Estabelecer parceiros de decisão",
        "set_rights": "Definir direitos de grupo para {partner_group_name}",
        "share_existing_title": "Partilhar propostas já aprovadas",
        "share_proposals_label": "Partilhar propostas",
        "start_date_description": "Data apenas para uso interno. Pode ser utilizada para determinar a ordem pela qual as decisões são trabalhadas pela sua equipa",
        "start_date_title": "Data de início (facultativo)",
        "step0Title": "Que modelo de projeto e decisão pretende utilizar?",
        "step1Title": "Que tipo de decisão é que os seus clientes precisam de tomar?",
        "tab_proposal_templates": "Modelos de propostas",
        "tab_units": "Unidades",
        "upsellCategoryTypes": "Esta funcionalidade não está incluída no seu pacote. Contacte-nos através do botão azul para obter mais informações.",
        "view": "Ver",
        "view_list": "Lista",
        "view_table": "Tabela",
        "writeEmployeeNameReject": "Escreva <i><b>{employeeName}</b></i> para continuar."
      },
      "snackbars": {
        "duplicate": "A decisão foi criada, mas o processo de cópia do modelo pode demorar alguns minutos a ser concluído."
      },
      "toasts": {
        "bulk_delete": "Decisão eliminada com êxito | Decisões eliminadas com êxito",
        "update": "Decisão atualizada com sucesso"
      },
      "validation": {
        "duplicateNameAlreadyTaken": "'{name}' já foi escolhido para este projeto",
        "nameAlreadyTaken": "O nome já foi escolhido para este projeto",
        "needName": "O título é obrigatório",
        "projectRequired": "Selecionar primeiro um projeto",
        "selectDecisionType": "Selecionar pelo menos 1 decisão",
        "selectSharingOption": "Selecione com quem pretende partilhar o(s) documento(s)"
      }
    }
  }
}
